import React, { Component, Fragment } from 'react';
// components
import Icon from '../../Icon/Icon';
import { Collapse } from 'react-collapse';
// styles
import styles from './CollapseSection.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

class CollapseSection extends Component {
  state = {
    isOpen: false
  };

  toggleCollapse = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  render() {
    const { title, placeholder, children } = this.props;
    const { isOpen } = this.state;
    return children ? (
      <Fragment>
        <div className={styles.toggled}>
          <h3 onClick={this.toggleCollapse}>
            {title}
            <Icon
              type="chevron-up"
              className={cx('chevron', { rotated: isOpen })}
            />
          </h3>
        </div>
        <Collapse isOpened={isOpen}>{children}</Collapse>
      </Fragment>
    ) : (
      <Fragment>
        <h3>{title}</h3>
        <p className={cx('placeholder')}>{placeholder}</p>
      </Fragment>
    );
  }
}

export default CollapseSection;



// WEBPACK FOOTER //
// ./src/components/Sidebar/components/CollapseSection.jsx